import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import * as animationData from './celebration.json';

function CelebrationAnimation() {




    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='vdo-btn'>
                <Lottie className="me-auto"
                    width={100}
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}

export default CelebrationAnimation;